/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouteLink} from 'react-router-dom'

// Components
import {
    Box,
    PopoverTrigger,

    // Hooks
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

// Project Components
import Link from '@salesforce/retail-react-app/app/components/link'

// Others
import {categoryUrlBuilder} from '../../utils/url'

const ListMenuTrigger = ({item, name, isOpen, isActive}) => {
    const baseStyle = useMultiStyleConfig('ListMenu', {})
    const cmsCategoryReplacement = item.CategoryReplacement?.ContentLink?.Expanded

    return (
        <Box {...baseStyle.listMenuTriggerContainer}>
            <PopoverTrigger data-testid="list-menu-popover-trigger">
                <Link
                    as={RouteLink}
                    to={categoryUrlBuilder(item)}
                    {...baseStyle.listMenuTriggerLink}
                    {...{name: name + ' __'}}
                    {...(isOpen || isActive
                        ? {
                              ...baseStyle.listMenuTriggerLinkActive
                          }
                        : {})}
                    /* CMS Props */
                    color={cmsCategoryReplacement?.TextColor}
                    backgroundColor={cmsCategoryReplacement?.TextBackgroundColor}
                >
                    {cmsCategoryReplacement?.OverrideName || name}
                </Link>
            </PopoverTrigger>
        </Box>
    )
}

ListMenuTrigger.propTypes = {
    item: PropTypes.object,
    name: PropTypes.string,
    isOpen: PropTypes.bool,
    isActive: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
}

export {ListMenuTrigger}
